import React, { useEffect, useState } from "react"
import Lightbox from 'react-image-lightbox';

const FsLight = (props) => { 

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openLighboxMobile = (e, ind) => {
      e.preventDefault();
      setPhotoIndex(ind);
      setIsOpen(true);
  }
  var lightImages2 = props?.images && props?.images.map(img => img.hd_url);


    return (<>
      <li className="img-count"><a onClick={(e) => openLighboxMobile(e, 0)} class="icon-gallery"></a> </li>
      {isOpen && (
                            <Lightbox
                                mainSrc={lightImages2[photoIndex]}
                                nextSrc={lightImages2[(photoIndex + 1) % lightImages2.length]}
                                prevSrc={lightImages2[(photoIndex + lightImages2.length - 1) % lightImages2.length]}
                                onCloseRequest={() => setIsOpen(false)}
                                onMovePrevRequest={() =>
                                    setPhotoIndex((photoIndex + lightImages2.length - 1) % lightImages2.length)
                                }
                                onMoveNextRequest={() =>
                                    setPhotoIndex((photoIndex + 1) % lightImages2.length)
                                }
                            />
                        )}
                        </>)
}

export default FsLight